import clsx from 'clsx';
import { FC } from 'react';
import { FilterComboBox, FilterComboBoxProps } from '../../components/FilterComboBox';
import { root } from './SessionsFilterComboBox.module.scss';

export const SessionsFilterComboBoxView: FC<FilterComboBoxProps> = ({ className, ...rest }) => {
  return <FilterComboBox className={clsx(root, className)} {...rest} />;
};
